"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDown = _interopRequireDefault(require("./IconArrowDown"));
var IconArrowRight = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDown.default).withConfig({
  displayName: "IconArrowRight",
  componentId: "c11n-8-107-0__sc-1bez2s0-0"
})(["transform:rotate(270deg);"]);
var _default = IconArrowRight;
exports.default = _default;